export const CURRENCY_LOGO_FALLBACK_SRC = 'https://via.placeholder.com/50';
export const TRANSACTIONS_TITLE = 'Transactions';
export const TRANSACTION_LIMIT = 10;
export const TRANSACTION_TABLE_HEADINGS = [
  'Date',
  'Transaction ID',
  'Description',
  'Amount',
  'Currency',
  'Transaction Type',
  'Transfer Type',
  'Status',
];
export const TRANSACTION_FOR_APPROVAL_TABLE_HEADINGS = [
  'Date',
  'Transaction ID',
  'Description',
  'Amount',
  'Currency',
  'Transfer Type',
  'Action',
];
export const TRANSACTION_STATUS = {
  ACTIVE: 'active',
  INITIATED: 'initiated',
  FAILED: 'failed',
  SUCCEEDED: 'succeeded',
  IN_REVIEW: 'in_review',
  FAILED_DUE_TO_COMPLIANCE: 'failed_due_to_compliance',
  UNKNOWN: 'unknown',
  DELAYED: 'delayed',
  UNMAPPED: 'unmapped',
  RFI_REQUESTED: 'rfi_requested',
};
export const MERCHANT_CORRIDOR_TABLE_HEADINGS = [
  'Corridor Mapping ID',
  'Source Currency',
  'Destination Currency',
  'Type',
  'Status',
  '',
];

export const AVAILABLE_CORRIDORS_TABLE_HEADINGS = [
  'Corridor ID',
  'Source Currency Code',
  'Destination Currency Code',
  'Type',
  '',
];

export const KYB_STATUS = {
  NOT_INITIATED: 'not_initiated',
  INITIATED: 'initiated',
  SUCCEEDED: 'succeeded',
  APPROVED: 'approved',
};

export const ENTITY_OWNER_DOCUMENT_TYPES = [
  {
    label: 'Tax Identification Document',
    value: 'tax_identification_document',
  },
  {
    label: 'Passport',
    value: 'passport_document',
  },
  {
    label: 'Address Proof Document',
    value: 'address_proof_document',
  },
  {
    label: 'Certificate of Incorporation',
    value: 'incorporation_certificate',
  },
  {
    label: 'Memorandum of Association',
    value: 'memorandum_of_association',
  },
  {
    label: 'Articles of Association',
    value: 'articles_of_association',
  },
  {
    label: 'Shareholder Register',
    value: 'shareholder_register',
  },
  {
    label: 'Directors Register',
    value: 'directors_register',
  },
  {
    label: 'W-8BEN',
    value: 'w_8ben',
  },
  {
    label: 'Incumbency Certificate',
    value: 'incumbency_certificate',
  },
  {
    label: 'Certificate of Good Standing',
    value: 'certificate_of_good_standing',
  },
  {
    label: 'Company Bylaws',
    value: 'company_by_laws',
  },
  {
    label: 'RFI Document',
    value: 'rfi_document',
  },
  {
    label: 'Company Address Proof',
    value: 'company_address_proof_document',
  },
];

export const ENTITY_OWNER_DOCUMENT_UPLOAD_ID = 'entity_owner_document_upload';

export const FILE_SIZE = {
  ONE_MB: 1048576,
  TWO_MB: 20971520,
  THREE_MB: 3145728,
};

export const FILE_MIME_TYPE = {
  'application/pdf': 'pdf',
  'image/jpeg': 'jpeg',
  'image/png': 'png',
  'image/bmp': 'bmp',
};

export const FILE_EXTENSION_TO_TYPE_MAPPING = {
  pdf: 'application/pdf',
  jpeg: 'image/jpeg',
  png: 'image/png',
  bmp: 'image/bmp',
};

export const INPUT_FILE_FORMATS = {
  PNG: 'image/png',
  JPEG: 'image/jpeg',
  JPG: 'image/jpg',
  PDF: '.pdf',
  BMP: '.bmp',
  MP4: 'video/mp4',
};

export const FILE_EXTENSION_TO_INPUT_FORMAT_MAPPING = {
  pdf: INPUT_FILE_FORMATS.PDF,
  jpeg: INPUT_FILE_FORMATS.JPEG,
  png: INPUT_FILE_FORMATS.PNG,
  bmp: INPUT_FILE_FORMATS.BMP,
  jpg: INPUT_FILE_FORMATS.JPG,
  mp4: INPUT_FILE_FORMATS.MP4,
};

export const TXN_STEP_ACTION_COLUMN = 'Action';

export const TXN_STEP_COLUMNS = [
  'Date',
  'Time',
  'Type',
  'Category ID',
  'Source Partner Code',
  'Destination Partner Code',
  'Source Amount',
  'Source Currency',
  'Destination Currency',
  'Status',
  'Failure Reason',
  TXN_STEP_ACTION_COLUMN,
];

export const TRANSACTION_QUOTES_VERSION_V2 = 'V2';

export const ELIGIBLE_PARTNER_CODES_FOR_KYT = ['ZAND', 'FIREBLOCKS_UAE'];

export const KYB_LINK_REGIONS = ['US', 'UAE', 'AFRICA'];

export const KYB_LINK_PARTNERS = ['aiprise', 'one_money', 'generic'];

export const KYC_DOCUMENT_PARENT_KEYS = [
  { label: 'National ID - Front Side', value: 'national_id_FRONT_SIDE' },
  { label: 'National ID - Back Side', value: 'national_id_BACK_SIDE' },
];

export const KYC_DOCUMENT_URL_KEY = 'document_url';

export const KYC_DOCUMENT_KEYS = [
  { label: 'Document Number', value: 'document_number' },
  { label: 'Document URL', value: KYC_DOCUMENT_URL_KEY },
  { label: 'Document Issued Date', value: 'document_issued_date' },
  { label: 'Document Expiry Date', value: 'document_expiry_date' },
];

export const SUBMIT_KYC_DOCUMENT_UPLOAD_ID = 'submit_kyc_document_upload';

export const KYB_NOT_AVAILABLE = 'Not available';

export const ONE_MONEY_DOCUMENT_KEY_PREFIX = 'one_money_doc_';

export const STANDARD_DOCUMENT_KEY_PREFIX = 'standard_doc_';

export const KYB_DOCUMENT_INDEX_PREFIX = 'document[';

export const KYB_SIGNED_DOCUMENT_KEYS = [
  'tax_identification_document',
  'passport_document',
  'document',
  'address_proof_document',
  'incorporation_certificate',
  'memorandum_of_association',
  'articles_of_association',
  'shareholder_register',
  'directors_register',
  'w_8ben',
  'incumbency_certificate',
  'certificate_of_good_standing',
  'company_by_laws',
  'rfi_document',
  'company_address_proof_document',
];

export const KYB_DOCUMENT_LABELS = {
  document: 'Document',
  tax_identification_document: 'Tax Identification document',
  passport_document: 'Passport',
  address_proof_document: 'Address Proof',
  incorporation_certificate: 'Certificate of Incorporation',
  memorandum_of_association: 'Memorandum / Articles of Association',
  articles_of_association: 'Articles of Association',
  shareholder_register: 'Shareholder Registry',
  directors_register: 'Register of Board of Directors',
  w_8ben: 'W-8BEN',
  incumbency_certificate: 'Incumbency Certificate',
  certificate_of_good_standing: 'Certificate of Good Standing',
  company_by_laws: 'Company Bylaws',
  rfi_document: 'RFI Document',
  company_address_proof_document: 'Company Address Proof',
  trade_license: 'Trade Licence',
  financial_statements: 'Financial statements / bank statements',
  ownership_structure_chart: 'Ownership structure chart',
  authorised_signatory_list: 'Authorised Signatories list',
  board_resolution: 'Board Resolution / Letter of Authorisation',
  source_of_funds_document: 'Source of Funds (SOF) documentation',
  ubo_source_of_funds_document: 'Source of funds (proof)',
  wolfsberg_questionnaire: 'Wolfsberg AML Questionnaire',
  financial_services_license: 'Financial Services License',
  aml_kyc_policy_manual: 'AML/KYC Policy Manual',
  money_transmission_license: 'Money Transmission License',
  sole_ownership_confirmation: 'Sole ownership & control confirmation',
  vara_noc: 'VARA NOC',
  intermediary_incorporation_certificate: 'Certificate of Incorporation or equivalent',
  intermediary_shareholders_register: 'Shareholders register or ownership confirmation',
  intermediary_proof_of_address: 'Proof of address',
  bank_ownership_proof: 'Bank Ownership Proof',
  wallet_ownership_proof: 'Wallet Ownership Proof',
};

export const KYB_FIELD_LABELS = {
  legal_business_name: 'Legal business name',
  company_name: 'Company name (Doing business as)',
  business_name: 'Legal business name',
  trade_name: 'Trade name (DBA)',
  ein: 'Registered Number (Business EIN, Business Number, FEIN, Taxpayer ID etc)',
  company_registration_number: 'Company registration number',
  tax_id: 'Tax ID',
  business_type: 'Company type',
  company_type: 'Company type',
  date_of_formation: 'Date of Incorporation',
  date_of_incorporation: 'Date of Incorporation',
  country_of_incorporation: 'Country of Incorporation',
  website: 'Company website',
  industry_type: 'Company industry type',
  industry: 'Company industry type',
  business_description: 'Description of business',
  description: 'Description of business',
  country_of_operations: 'Countries of Operation',
  total_empoyees: 'Total Number of Employees',
  annual_turnover: 'Annual turnover',
  external_id: 'External ID',

  purpose: 'Purpose',
  account_purpose: 'Account purpose',
  account_purpose_other: 'Account purpose (other)',
  intended_purpose_of_relationship: 'Intended purpose of relationship',
  estimated_annual_revenue_usd: 'Estimated annual revenue (USD)',
  monthly_fiat_deposit: 'Expected transaction volume in a month (USD)',
  monthly_fiat_withdrawl: 'Monthly Fiat Withdrawal',
  monthly_virtual_asset_deposit: 'Monthly Virtual Asset Deposit',
  monthly_virtual_asset_withdrawl: 'Monthly Virtual Asset Withdrawal',
  anticipated_monthly_fiat_activity: 'Anticipated monthly fiat activity',
  expected_transaction_count: 'Expected transaction count in a month',
  expected_transaction_frequency: 'Expected transaction frequency',
  flow_of_funds: 'Please elaborate on the exact flow of funds',
  is_public_company: 'Is the company publicly listed?',
  public_company_details: 'Public company details',
  operates_regulated_activity: 'Does the entity operate in a regulated industry?',
  regulated_activity_details: 'Regulator and licence number',
  revenue_model: 'Revenue Model',
  expected_transaction_flow: 'Expected transaction flow (fiat / crypto)',
  key_counterparties_geographies: 'Key counterparties / geographies',
  source_of_funds: 'Source of Funds',
  source_of_funds_details: 'Source of Funds Details',
  source_of_wealth: 'Source of Wealth',
  source_of_wealth_details: 'Source of Wealth Details',

  ownership_structure: 'Ownership structure',
  ownership_percentage: 'Ownership percentage',
  ownership: 'Ownership percentage',
  has_ownership: 'Has an ownership stake in the business',
  has_control: 'Exercises significant control over the business',
  is_director: 'Serves as a director of the business',
  is_signer: 'Is an authorized signer for the business',
  owner_title: 'Title',
  owner_profile: 'Relationship to company',
  owner_profile_other: 'Others (Please specify)',

  first_name: 'First name',
  last_name: 'Last name',
  email: 'Email address',
  email_id: 'Primary contact email',
  business_email: 'Business email',
  compliance_email: 'Compliance email',
  phone_number: 'Phone number',
  date_of_birth: 'Date of Birth',
  dob: 'Date of Birth',
  primary_nationality: 'Primary nationality',
  nationality: 'Primary nationality',
  dual_nationality: 'Dual nationality',
  country_of_residence: 'Country of residence',
  tax_info_country: 'Tax country',
  tax_info_number: 'Tax identifier',
  tax_country: 'Tax country',
  tax_type: 'Tax ID type',
  tax_number: 'Tax identifier',
  passport_issuing_country: 'Passport issuing country',
  passport_id_number: 'Passport ID number',
  id_type: 'Identity document type',
  id_number: 'Identity document number',
  id_issuing_country: 'Identity document issuing country',
  ssn: 'Social Security Number',

  address1: 'Street address',
  address2: 'Address line 2',
  city: 'City',
  state: 'State',
  country: 'Country',
  zip_code: 'ZIP or postal code',
  address: 'Address',
  registered_address: 'Registered address',
  operating_address: 'Operating address',
  residential_address: 'Residential address',
  'registered_address.country': 'Country (registered address)',
  'registered_address.address1': 'Street address (registered address)',
  'registered_address.city': 'City (registered address)',
  'registered_address.state': 'State (registered address)',
  'registered_address.zip_code': 'ZIP or postal code (registered address)',
  'current_address.country': 'Country (current address)',
  'current_address.address1': 'Street address (current address)',
  'current_address.city': 'City (current address)',
  'current_address.state': 'State (current address)',
  'current_address.zip_code': 'ZIP or postal code (current address)',
  'current_address.same_as_registered_address': 'Is current address same as registered address?',

  entity_name: 'Entity name',

  account_holder_name: 'Name of the Account Holder',
  iban: 'IBAN',
  settlement_bank_details: 'Details of the Bank (Name, address, etc.)',
  wallet_address: 'Wallet Address',
  wallet_provider_name: 'Name of the Wallet Provider',
  wallet_network: 'Network supported by the wallet',
  wallet_custody_type: 'Custodial / Non-Custodial Wallet',

  signed_timestamp: 'Terms accepted at',
  viewed_timestamp: 'Terms viewed at',
  ip_address: 'End-user IP (T&C consent)',

  occupation: 'Occupation',
  employment_status: 'Employment status',
  profile_source_of_funds: 'Source of Funds',
  profile_purpose_of_account: 'Purpose of account',
  estimated_transaction_volume: 'Estimated transaction volume',
  identification_type: 'Identity document type',
  identification_number: 'Identity document number',
  identification_issuing_country: 'Identity document issuing country',
  identification_issued_at: 'Identity document issued on',
  identification_expires_at: 'Identity document expires on',
  phone_country_code: 'Phone country code',
  partner_code: 'Onboarding partner',

  one_money_business_account_id: '1Money business account ID',
  one_money_controller_id_map: '1Money controller IDs',
  one_money_individual_account_id: '1Money individual account ID',
  one_money_parent_account_id: '1Money parent account ID',
  one_money_kyc_status: '1Money KYC status',
  one_money_required_documents: '1Money required documents',
  one_money_account_limits: '1Money account limits',
  one_money_last_submit_error: '1Money last submission error',
};

export const KYB_FIELD_LABEL_OVERRIDES = {
  company_details: {
    email: 'Company email address',
    phone_number: 'Company phone number',
    country: 'Country of Incorporation',
    state: 'State of Incorporation',
  },
  incorporation_documents: {
    country: 'Country of Incorporation',
  },
  business: {
    industry: 'Industry',
    description: 'Business description',
    first_name: 'Primary contact first name',
    last_name: 'Primary contact last name',
  },
};

export const KYB_SECTION_LABELS = {
  individual_details: 'Individual Details',
  one_money_partner_audit: 'Partner exchange (1Money)',
  company_details: 'Company / Entity Verification',
  company_address: 'Company address',
  incorporation_documents: 'Incorporation Documents',
  ownership_control: 'Ownership & Control Structure',
  company_owners: 'Beneficial Owner / Director / Authorised Signatory',
  controller: 'Controller (submitted to partner)',
  intermediaries: 'Intermediate Holding Entity',
  intermediary: 'Intermediate Holding Entity (submitted to partner)',
  key_personnel: 'Key Personnel',
  business_profile: 'Business Profile Information',
  source_of_funds_information: 'Source of Funds',
  source_of_funds_and_wealth: 'Source of Funds & Source of Wealth',
  entity_type_documents: 'Entity-type Related Documents',
  bank_wallet_details: 'Bank and Wallet Ownership',
  business_document: 'Company document',
  additional_business_document: 'Additional company documents',
  tnc_section: 'Terms and Conditions',
  business: 'Submitted to partner',
  other: 'Other details',
};

export const KYB_SECTION_ORDER = [
  'individual_details',
  'company_details',
  'incorporation_documents',
  'company_address',
  'ownership_control',
  'key_personnel',
  'business_profile',
  'source_of_funds_and_wealth',
  'source_of_funds_information',
  'entity_type_documents',
  'bank_wallet_details',
  'intermediaries',
  'intermediary',
  'controller',
  'business_document',
  'additional_business_document',
  'tnc_section',
  'business',
  'one_money_partner_audit',
  'other',
];

export const KYB_SECTION_FIELD_ORDER = {
  company_details: [
    'legal_business_name',
    'company_name',
    'business_type',
    'ein',
    'email',
    'phone_number',
    'website',
    'date_of_formation',
    'country_of_incorporation',
    'registered_address.country',
    'registered_address.state',
    'registered_address.city',
    'registered_address.address1',
    'registered_address.zip_code',
  ],
  business_profile: [
    'industry_type',
    'business_description',
    'purpose',
    'flow_of_funds',
    'source_of_funds',
    'source_of_funds_details',
    'source_of_wealth',
    'source_of_wealth_details',
    'estimated_annual_revenue_usd',
    'monthly_fiat_deposit',
    'expected_transaction_count',
    'is_public_company',
    'public_company_details',
    'operates_regulated_activity',
    'regulated_activity_details',
  ],
  ownership_control: ['ownership_structure'],
  intermediaries: ['entity_name', 'country', 'ownership_percentage'],
  intermediary: ['entity_name', 'country', 'ownership'],
  controller: [
    'first_name',
    'last_name',
    'email',
    'dob',
    'nationality',
    'dual_nationality',
    'ownership_percentage',
    'has_ownership',
    'has_control',
    'is_director',
    'is_signer',
    'id_type',
    'id_number',
    'id_issuing_country',
    'tax_country',
    'tax_type',
    'tax_number',
    'residential_address',
  ],
  business: [
    'one_money_business_account_id',
    'one_money_controller_id_map',
    'business_name',
    'trade_name',
    'company_type',
    'tax_id',
    'company_registration_number',
    'date_of_incorporation',
    'country_of_incorporation',
    'industry',
    'description',
    'website',
    'business_email',
    'compliance_email',
    'email_id',
    'first_name',
    'last_name',
    'phone_number',
    'registered_address',
    'operating_address',
    'address',
    'signed_timestamp',
    'viewed_timestamp',
    'ip_address',
  ],
};

export const KYB_VALUE_LABELS = {
  '0_99999': '$0 - $99,999',
  '100000_999999': '$100,000 - $999,999',
  '1000000_9999999': '$1,000,000 - $9,999,999',
  '10000000_49999999': '$10,000,000 - $49,999,999',
  '50000000_249999999': '$50,000,000 - $249,999,999',
  '250000000_plus': '$250,000,000+',

  CORPORATION: 'Corporation',
  LLC: 'LLC',
  LTD: 'Ltd',
  PARTNERSHIP: 'Partnership',
  SOLE_PROPRIETORSHIP: 'Sole Proprietorship',
  SOCIETIES: 'Societies',
  TRUST: 'Trust',
  GOVERNMENT: 'Government',
  DAO: 'DAO',
  FOUNDATION: 'Foundation',
  NON_PROFIT: 'Non-Profit',

  PUBLICLY_LISTED_COMPANY: 'Publicly Listed Company',
  WHOLLY_OWNED_SUBSIDIARY_OF_PUBLICLY_LISTED_COMPANY: 'Wholly Owned Subsidiary of a Publicly Listed Company',
  MAJORITY_OWNED_SUBSIDIARY_OF_PUBLICLY_LISTED_COMPANY: 'Majority Owned Subsidiary of a Publicly Listed Company',
  WHOLLY_OWNED_SUBSIDIARY_OF_FI_OR_NBFI: 'Wholly Owned Subsidiary of an FI or NBFI',
  MAJORITY_OWNED_SUBSIDIARY_OF_FI_OR_NBFI: 'Majority Owned Subsidiary of an FI or NBFI',
  PRIVATELY_OWNED: 'Privately Owned',
  FUND: 'Fund',
  OWNED_BY_TRUST: 'Owned by Trust',

  CHARITABLE_DONATIONS: 'Charitable Donations',
  ECOMMERCE_RETAIL_PAYMENTS: 'E-commerce / Retail Payments',
  INVESTMENT_PURPOSES: 'Investment Purposes',
  PAYMENTS_TO_FRIENDS_OR_FAMILY_ABROAD: 'Payments to Friends or Family Abroad',
  PAYROLL: 'Payroll',
  PERSONAL_OR_LIVING_EXPENSES: 'Personal or Living Expenses',
  PROTECT_WEALTH: 'Protect Wealth',
  PURCHASE_GOODS_AND_SERVICES: 'Purchase Goods and Services',
  RECEIVE_PAYMENTS_FOR_GOODS_AND_SERVICES: 'Receive Payments for Goods and Services',
  TAX_OPTIMIZATION: 'Tax Optimization',
  THIRD_PARTY_MONEY_TRANSMISSION: 'Third Party Money Transmission',
  TREASURY_MANAGEMENT: 'Treasury Management',
  OTHER: 'Other',

  BUSINESS_LOANS: 'Business Loans',
  GRANTS: 'Grants',
  INTER_COMPANY_FUNDS: 'Inter-Company Funds',
  INVESTMENT_PROCEEDS: 'Investment Proceeds',
  LEGAL_SETTLEMENT: 'Legal Settlement',
  OWNERS_CAPITAL: "Owner's Capital",
  PENSION_RETIREMENT: 'Pension / Retirement',
  SALE_OF_ASSETS: 'Sale of Assets',
  SALES_OF_GOODS_AND_SERVICES: 'Sales of Goods and Services',
  TAX_REFUND: 'Tax Refund',
  THIRD_PARTY_FUNDS: 'Third Party Funds',
  TREASURY_RESERVES: 'Treasury Reserves',

  BUSINESS_DIVIDENDS_OR_PROFITS: 'Business Dividends or Profits',
  INVESTMENTS: 'Investments',
  ASSET_SALES: 'Asset Sales',

  PASSPORT: 'Passport',
  NATIONAL_ID: 'National ID',
  DRIVERS_LICENSE: "Driver's Licence",

  ACCOMMODATION_AND_FOOD_SERVICE: 'Accommodation and Food Service',
  ADMINISTRATIVE_SUPPORT_SERVICES: 'Administrative Support Services',
  ADULT_ENTERTAINMENT: 'Adult Entertainment',
  AGRICULTURE_FORESTRY_FISHING: 'Agriculture, Forestry & Fishing',
  ARMS_INDUSTRY: 'Arms Industry',
  ARTS_ENTERTAINMENT_RECREATION: 'Arts, Entertainment & Recreation',
  BANKING_RFI: 'Banking / RFI',
  BROKERAGE_OTC: 'Brokerage / OTC',
  CEX_DEX: 'CEX / DEX',
  CONSTRUCTION: 'Construction',
  CRYPTO_ATM: 'Crypto ATM',
  CRYPTO_CARDS: 'Crypto Cards',
  CRYPTO_CUSTODY: 'Crypto Custody',
  CRYPTO_GIFT_CARDS: 'Crypto Gift Cards',
  CRYPTO_MINING: 'Crypto Mining',
  DAO_FOUNDATION: 'DAO / Foundation',
  DEFI: 'DeFi',
  EDUCATION: 'Education',
  FAMILY_OFFICE: 'Family Office',
  GAMBLING: 'Gambling',
  GAMING_METAVERSE: 'Gaming / Metaverse',
  HEALTHCARE: 'Healthcare',
  HOLDING_COMPANY: 'Holding Company',
  INVESTMENT_FUND: 'Investment Fund',
  MANUFACTURING: 'Manufacturing',
  MARIJUANA: 'Marijuana',
  MEDIA: 'Media',
  MINING_EXTRACTION: 'Mining & Extraction',
  MSB_PSP: 'MSB / PSP',
  NFT_MARKETPLACE: 'NFT Marketplace',
  NON_BANK_FI: 'Non-Bank Financial Institution',
  NON_CUSTODIAL_WALLET: 'Non-Custodial Wallet',
  OIL_GAS: 'Oil & Gas',
  P2P_MERCHANTS: 'P2P Merchants',
  PAWN_SHOPS: 'Pawn Shops',
  PERSONAL_INVESTMENT: 'Personal Investment',
  PHARMACEUTICALS: 'Pharmaceuticals',
  PLAY_TO_EARN: 'Play to Earn',
  PRECIOUS_METALS: 'Precious Metals',
  PROFESSIONAL_SERVICES: 'Professional Services',
  PROP_TRADING_MARKET_MAKING: 'Proprietary Trading / Market Making',
  PUBLIC_ADMIN: 'Public Administration',
  REAL_ESTATE: 'Real Estate',
  RETAIL_ELECTRONICS: 'Retail - Electronics',
  RETAIL_FNB: 'Retail - Food & Beverage',
  RETAIL_JEWELRY: 'Retail - Jewelry',
  RETAIL_OTHER: 'Retail - Other',
  SCIENTIFIC_TECHNICAL: 'Scientific & Technical',
  SOFTWARE_DEVELOPMENT: 'Software Development',
  SOVEREIGN_WEALTH: 'Sovereign Wealth',
  STABLECOIN_ISSUER: 'Stablecoin Issuer',
  TECHNOLOGY_ECOMMERCE: 'Technology / E-commerce',
  TOBACCO: 'Tobacco',
  TRANSPORTATION: 'Transportation',
  UNLICENSED_GAMBLING: 'Unlicensed Gambling',
  UTILITIES: 'Utilities',
  VENTURE_CAPITAL_PE: 'Venture Capital / Private Equity',
  WEB3_CRYPTO_NATIVE: 'Web3 / Crypto Native',
  WHOLESALERS: 'Wholesalers',
};

export const KYB_PARTNER_DOCUMENT_TYPE_LABELS = {
  CERT_OF_INC: 'Certificate of Incorporation',
  TRADE_LICENCE: 'Trade Licence',
  MEMORANDUM_OF_ASSOCIATION: 'Memorandum / Articles of Association',
  ARTICLES_OF_ASSOCIATION: 'Articles of Association',
  BY_LAWS: 'Company Bylaws',
  PROOF_OF_BUS_ADDR: 'Company Address Proof',
  FINANCIAL_STATEMENT: 'Financial statements / bank statements',
  BANK_STATEMENT: 'Bank statement',
  OWNERSHIP_STRUCTURE_CHART: 'Ownership structure chart',
  SHAREHOLDERS_REGISTER: 'Shareholders register',
  REGISTER_OF_DIRECTORS: 'Register of Board of Directors',
  AUTHORISED_SIGNATORY_LIST: 'Authorised Signatories list',
  BOARD_RESOLUTION: 'Board Resolution / Letter of Authorisation',
  LETTER_OF_AUTHORIZATION: 'Letter of Authorisation',
  PROOF_OF_FUNDS: 'Proof of funds',
  SOURCE_OF_FUNDS_EVIDENCE: 'Source of Funds (SOF) documentation',
  SOURCE_OF_WEALTH_EVIDENCE: 'Source of Wealth evidence',
  AUDITED_FINANCIAL_STATEMENTS: 'Audited financial statements',
  HIGH_VALUE_TXN_RATIONALE: 'High value transaction rationale',
  EXPECTED_ACTIVITY_PROFILE: 'Expected activity profile',
  WOLFSBERG_AML_QUESTIONNAIRE: 'Wolfsberg AML Questionnaire',
  FINANCIAL_SERVICES_LICENCE: 'Financial Services License',
  AML_KYC_POLICY_MANUAL: 'AML/KYC Policy Manual',
  MONEY_TRANSMISSION_LICENCE: 'Money Transmission License',
  SOLE_OWNERSHIP_CONTROL_CONFIRMATION: 'Sole ownership & control confirmation',
  VARA_NOC: 'VARA NOC',
  LICENCE: 'Licence',
  BANK_OWNERSHIP_PROOF: 'Bank Ownership Proof',
  WALLET_OWNERSHIP_PROOF: 'Wallet Ownership Proof',
  ID_FRONT: 'Identity document - front',
  ID_BACK: 'Identity document - back',
  POA: 'Address Proof',
  OP_LP_AGREE: 'Operating / LP Agreement',
};

export const KYB_DOCUMENT_OWNER_LABELS = {
  company: 'Company',
  controller: 'Controller',
  intermediary: 'Intermediate holding entity',
};

export const KYB_COMPANY_DETAILS_LOOKUPS = {
  legalBusinessName: ['legal_business_name_company_details'],
  companyName: ['company_name_company_details', 'trade_name_business'],
  dateOfIncorporation: [
    'date_of_formation_company_details',
    'date_of_formation_incorporation_documents',
    'date_of_incorporation_business',
  ],
  companyType: ['business_type_company_details', 'company_type_business'],
  ownershipStructure: ['ownership_structure_company_details', 'ownership_structure_ownership_control'],
  sourceOfFunds: ['source_of_funds_company_details', 'source_of_funds_business'],
  purpose: ['purpose_company_details', 'purpose_business_profile'],
  website: ['website_company_details', 'website_business'],
  taxIdentificationNumber: ['ein_company_details', 'tax_id_business'],
  phoneNumber: ['phone_number_company_details'],
  email: ['email_company_details', 'business_email_business', 'email_id_business'],
  industryType: ['industry_type_company_details', 'industry_type_business_profile', 'industry_business'],
  businessDescription: [
    'business_description_company_details',
    'business_description_business_profile',
    'description_business',
  ],
  countryOfOperations: ['country_of_operations_company_details'],
  totalEmployees: ['total_empoyees_company_details'],
  annualTurnover: ['annual_turnover_company_details'],
  estimatedAnnualRevenue: [
    'estimated_annual_revenue_usd_company_details',
    'estimated_annual_revenue_usd_business_profile',
    'estimated_annual_revenue_usd_business',
  ],
  countryOfIncorporation: [
    'country_company_details',
    'country_of_incorporation_company_details',
    'country_of_incorporation_incorporation_documents',
    'country_of_incorporation_business',
  ],
  stateOfIncorporation: ['state_company_details'],
  monthlyVirtualAssetDeposit: ['monthly_virtual_asset_deposit_company_details'],
  monthlyVirtualAssetWithdrawal: ['monthly_virtual_asset_withdrawl_company_details'],
  monthlyFiatDeposit: ['monthly_fiat_deposit_company_details', 'monthly_fiat_deposit_business_profile'],
  monthlyFiatWithdrawal: ['monthly_fiat_withdrawl_company_details'],
};

const registeredAddressLookup = (field) => [
  `${field}_company_address`,
  `registered_address.${field}_company_address`,
  `registered_address.${field}_company_details`,
  `registered_address.${field}_incorporation_documents`,
];

const currentAddressLookup = (field) => [
  `${field}_company_address`,
  `current_address.${field}_company_address`,
  `current_address.${field}_incorporation_documents`,
  `registered_address.${field}_company_address`,
  `registered_address.${field}_company_details`,
  `registered_address.${field}_incorporation_documents`,
];

export const KYB_COMPANY_ADDRESS_LOOKUPS = {
  registeredCountry: registeredAddressLookup('country'),
  registeredAddress1: registeredAddressLookup('address1'),
  registeredCity: registeredAddressLookup('city'),
  registeredState: registeredAddressLookup('state'),
  registeredZipCode: registeredAddressLookup('zip_code'),
  currentSameAsRegistered: [
    'current_address.same_as_registered_address_company_address',
    'current_address.same_as_registered_address_incorporation_documents',
  ],
  currentCountry: currentAddressLookup('country'),
  currentAddress1: currentAddressLookup('address1'),
  currentCity: currentAddressLookup('city'),
  currentState: currentAddressLookup('state'),
  currentZipCode: currentAddressLookup('zip_code'),
};

export const KYB_COMPANY_OWNER_LOOKUP_KEYS = [
  'first_name',
  'last_name',
  'phone_number',
  'email',
  'date_of_birth',
  'primary_nationality',
  'owner_profile',
  'owner_profile_other',
  'owner_title',
  'ownership_percentage',
  'is_director',
  'is_signer',
  'has_control',
  'has_ownership',
  'passport_issuing_country',
  'passport_id_number',
  'tax_info_number',
  'tax_info_country',
  'country',
  'address1',
  'city',
  'state',
  'zip_code',
];

export const KYB_BUSINESS_DOCUMENT_LOOKUP_KEYS = ['document', 'document_type'];
